import { IdentifierTypeViewModel } from '../../models/Entities/Person/IdentifierType/IdentifierTypeModels';
import { CommonState } from '../common/state/commonState';

export interface PersonIdentifierTypeState extends CommonState<IdentifierTypeViewModel> {
    lastCreated?: IdentifierTypeViewModel;
}

export const PersonIdentifierTypeUnloadState: PersonIdentifierTypeState = {
    isLoadingAll: false,
    successLoadingAll: undefined,
    failOnLoadingAll: false,

    isLoadingOne: false,
    successLoadingOne: undefined,
    failOnLoadingOne: false,

    isAddingNewOne: false,
    successAddingNewOne: undefined,
    failOnAddingNewOne: false,

    isUpdatingOne: false,
    successUpdatingOne: undefined,
    failOnUpdatingOne: false,

    isDeletingOne: false,
    successDeletingOne: undefined,
    failOnDeletingOne: false,

    list: [],
    error: undefined,
    lastCreated: undefined
};
